import React, { useContext } from 'react';

import { IonIcon } from '@ionic/react';

import clsx from 'clsx';

import Typography from 'components/Typography';

import TypographyListContext from './TypographyListContext';
import './index.css';

interface TypographyListItemConfig {
  icon?: JSX.Element | string;
  iconProps?: object;
  type?: 'bullet' | 'icon' | 'none';
  lineClamp?: number;
  variant?:
    | 'title'
    | 'subtitle1'
    | 'subtitle2'
    | 'body2'
    | 'caption'
    | 'overline';
  color?:
    | 'primary'
    | 'primary-contrast'
    | 'primary-shade'
    | 'primary-tint'
    | 'success'
    | 'success-contrast'
    | 'success-shade'
    | 'success-tint'
    | 'warning'
    | 'warning-contrast'
    | 'warning-shade'
    | 'warning-tint'
    | 'danger'
    | 'danger-contrast'
    | 'danger-shade'
    | 'danger-tint'
    | 'dark'
    | 'dark-contrast'
    | 'dark-shade'
    | 'dark-tint'
    | 'medium'
    | 'medium-contrast'
    | 'medium-shade'
    | 'medium-tint'
    | 'light'
    | 'light-contrast'
    | 'light-shade'
    | 'light-tint'
    | string;
  TypographyProps?: object;
}

export const TypographyListItem: React.FC<TypographyListItemConfig> = ({
  children,
  TypographyProps,
  ...props
}) => {
  const listContext = useContext(TypographyListContext);

  const {
    variant,
    color,
    icon,
    iconProps,
    type = 'bullet',
    lineClamp,
    ...other
  } = {
    ...listContext,
    ...props,
  };

  return (
    <div
      className={clsx('typography-list-item', `ion-text-color-${color}`, {
        ['actions']: type === 'bullet' || type === 'icon',
        ['bullet']: type === 'bullet' && !icon,
      })}
      {...other}
    >
      {icon ? (
        <div className={'typography-list-icon'}>
          {typeof icon === 'string' ? (
            <IonIcon icon={icon} {...iconProps} />
          ) : (
            icon
          )}
        </div>
      ) : null}
      <Typography
        variant={variant}
        color={color}
        lineClamp={lineClamp}
        {...TypographyProps}
      >
        {children}
      </Typography>
    </div>
  );
};
